const l = "content", u = (e) => {
  const t = document.querySelector(`meta[name='${e}']`);
  return t === null ? [new Error(`meta tag with name ${e} does not exist`), null] : [null, t.getAttribute(l) || ""];
}, s = (e) => {
  try {
    const [t, n] = u(e);
    return t !== null ? [t, null] : [null, JSON.parse(n)];
  } catch (t) {
    return [t, null];
  }
}, m = (e) => {
  const t = document.querySelectorAll(`meta[name^='${e}']`), n = {};
  for (const r of t) {
    const o = r.getAttribute("name"), c = r.getAttribute(l);
    try {
      n[o] = JSON.parse(c || "");
    } catch (a) {
      n[o] = c;
    }
  }
  return n;
};
export {
  s as getJSONTagContent,
  m as getMatchingTags,
  u as getTagContent
};
